export const KEY_PREFIX = { JOB_MODIFICATION: "apt_jobmodification_" } as const;
